import { render } from "./resumption-from-leave.vue?vue&type=template&id=32f17d8f"
import script from "./resumption-from-leave.vue?vue&type=script&lang=js"
export * from "./resumption-from-leave.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__